import React from "react";

function NodeIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="url(#gradient)"
            viewBox="0 0 16 16"
        >
            <path
                d="M7.586.102a.75.75 0 01.756 0l6.214 3.625a.75.75 0 01.373.648v7.25a.75.75 0 01-.373.648l-6.214 3.625a.75.75 0 01-.756 0l-1.553-.906a.75.75 0 01.756-1.296l1.175.686 5.465-3.188V4.806L7.964 1.618 2.5 4.806v6.388l1.117.652c.344.11.77.137 1.069.005a.75.75 0 00.364-.34c.104-.188.2-.501.2-1.011V5.25a.75.75 0 011.5 0v5.25c0 .69-.129 1.272-.39 1.74a2.25 2.25 0 01-1.068.983c-.806.356-1.697.21-2.242.014a.75.75 0 01-.124-.058l-1.554-.906A.75.75 0 011 11.625v-7.25a.75.75 0 01.372-.648L7.586.102zm.66 5.181c.397-.472 1.017-.783 1.858-.783.78 0 1.375.268 1.778.693a.75.75 0 11-1.09 1.03C10.703 6.132 10.52 6 10.103 6c-.442 0-.624.148-.709.248a.642.642 0 00-.145.377c0 .083.036.247.145.377.085.1.267.248.71.248a.75.75 0 01.212.03c.62.09 1.092.368 1.416.753.372.443.496.967.496 1.342 0 .375-.124.899-.496 1.342-.397.472-1.017.783-1.858.783-.78 0-1.375-.268-1.777-.693a.75.75 0 011.09-1.03c.087.092.271.223.687.223.442 0 .625-.148.71-.248a.642.642 0 00.144-.377.642.642 0 00-.145-.377c-.084-.1-.267-.248-.709-.248a.75.75 0 01-.213-.03c-.62-.09-1.092-.368-1.415-.753a2.137 2.137 0 01-.497-1.342c0-.375.124-.899.497-1.342z"
            ></path>
        </svg>
    );
}

export default NodeIcon;